import { Box } from "@mui/material";

export function DailyReportsPage() {
  return <Box sx={{ p: 2 }}>DailyReports page</Box>;
}
